<script setup>
import { ref } from 'vue'
import { useLoadingBar } from '@/composables/loadingBar'

const { withLoadingBar } = useLoadingBar()

const loading = ref(false)

async function handleClick (event, listeners) {
  try {
    loading.value = true
    await withLoadingBar(async () => await listeners?.click?.(event))
  } finally {
    loading.value = false
  }
}
</script>
<template>
  <button
    :disabled="loading"
    :class="{ disabled: loading }"
    @click.stop.prevent="handleClick($event, $listeners)"
  >
    <slot />
  </button>
</template>
